import { render, staticRenderFns } from "./BClipboard.vue?vue&type=template&id=3a738438&scoped=true"
import script from "./BClipboard.vue?vue&type=script&lang=js"
export * from "./BClipboard.vue?vue&type=script&lang=js"
import style0 from "./bottom-clipboard.scss?vue&type=style&index=0&id=3a738438&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a738438",
  null
  
)

export default component.exports